module.exports = __webpack_public_path__ + "static/media/flu.0a1445ad.svg";